// All Routes
export const loginRoute = `/login`;
export const signUpRoute = `/invites/verify-invite`;
export const usersRoute = `/users`;
export const rolesRoute = `/roles`;
export const centersRoute = `/centers`;
export const contactsRoute = `/contacts`;
export const createCenterRoute = `/create-center`;
export const editCenterRoute = `/edit-center`;
export const deleteCenterRoute = `/delete-center`;


export const userGroupsRoute = `/user-groups`;
export const pushNotificationRoute = `/push-notifications`;
export const dashboardRoute = `/`;
export const forgotPasswordRoute = `/forgotPassword`;
export const resetPasswordRoute = `/reset-password`;
export const OTPVerifyRoute = `/otp-verification`;
export const createUserRoute = `/create-user`;
export const modifyRolesRoute = `/update-roles`;
export const createGroupRoute = `/update-groups`;
export const groupAddRoute = `/add-to-group`;
export const editProfile = `/edit-profile`;
export const changePassword = `/change-password`;
export const preferences = `/preferences`;
export const termsAndConditions = `/terms-and-conditions`;
export const termsOfServiceRoute = `/terms`;
export const privacyPolicyRoute = `/privacy`;
export const createNotificationsRoute = `/create-notifications`;
export const clientRoute = `/clients`;
export const createClient = `/invite-client`;

// Fixafib Routes
export const patientsRoute = `/patients`;
export const tasksRoute = `/tasks`;
export const reportsRoute = `/reports`;
export const caseDaysRoute = `/case-days`;
export const registryRoute = `/registry`;
export const patientDetailRoute = `/patients/:id`;
export const createPatientRoute = `/create-patient`;

//Super Admin Routes
export const insurancesRoute = `/insurances`;
export const devicesRoute = `/devices`;
export const indicationsRoute = `/indications`;
export const specialtiesRoute = `/specialties`;
export const medicationsRoute = `/medications`;
export const medicationFrequenciesRoute = `/medication-frequencies`;
export const medicationHoldTimingsRoute = `/medication-hold-timings`;
export const centerLocationsRoute = `/center-locations`;
export const complicationsRoute = `/complications`;
export const messagesRoute = `/messages`;
export const callsRoute = `/calls`;
export const inboxRoute = `/inbox`;
export const messageTemplatesRoute = `/message-templates`;
/** Communication section — distinct from Management message templates */
export const communicationMessageTemplatesRoute = `/communication/message-templates`;
export const communicationEmailTemplatesRoute = `/communication/email-templates`;
export const communicationModesRoute = `/communication/modes`;
export const contactDropdownFiltersRoute = `/contact-dropdown-filters`;
export const subjectAccessRequestRoute = `/subject-access-request`;
export const subjectAccessRequestsManagementRoute = `/subject-access-requests`;
export const sarRequestsRoute = `/sar-requests`;
